enum BooleanType {
    TRUE = 'TRUE',
    FALSE = 'FALSE'
}

export default BooleanType;